<template>
  <div class="form-card">
    <v-tabs class="record-tab" v-model="tabsModel" @change="_tabSelect">
      <v-tab>{{$t('labels.acc.loginRecord.tag1')}}</v-tab>
      <v-tab>{{$t('labels.acc.loginRecord.tag2')}}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabsModel">
      <v-tab-item>
        <template v-if="!loginRecordData.loading">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left"
                    v-for="(item, index) in loginRecordData.columns"
                    :key="index"
                  >{{item.label}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in loginRecordData.list" :key="index">
                  <td>{{ setTimeZone(item.loginTime) }}</td>
                  <td>{{ item.loginIp }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-if="0 < loginRecordData.list.length" class="d-flex">
            <v-pagination
              v-model="loginRecordData.page.page"
              class="ml-auto pa-4"
              style="width: auto"
              :length="loginRecordData.page.totalPage"
              :total-visible="8"
              @input="loginRecordRequestRow"
            ></v-pagination>
          </div>
          <div class="pa-4" v-else>{{$t('common.noRecords')}}</div>
        </template>
        <template v-if="loginRecordData.loading">
          <div class="pa-4 text-center">
            <v-progress-circular :size="50" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="!securitySettingRecordData.loading">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left"
                    v-for="(item, index) in securitySettingRecordData.columns"
                    :key="index"
                  >{{item.label}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in securitySettingRecordData.list" :key="index">
                  <td>{{ item.ip }}</td>
                  <td>{{ item.action }}</td>
                  <td>{{ setTimeZone(item.time) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-if="0 < securitySettingRecordData.list.length" class="d-flex">
            <v-pagination
              v-model="securitySettingRecordData.page.page"
              class="ml-auto pa-4"
              style="width: auto"
              :length="securitySettingRecordData.page.totalPage"
              :total-visible="8"
              @input="securityRecordRequestRow"
            ></v-pagination>
          </div>
          <div class="pa-4" v-else>{{$t('common.noRecords')}}</div>
        </template>
        <template v-if="securitySettingRecordData.loading">
          <div class="pa-4 text-center">
            <v-progress-circular :size="50" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { loginRecordApi } from '@/api/user/loginRecord.page';
import { selectOption } from '@/common/constants/selectOption';
import tool from '@/common/js/tool';

export default {
  name: 'LoginRecord',
  data() {
    return {
      tabsModel: 1,
      // 路由参数
      params: {
        // 1为最近登录历史，2为安全设置历史
        type: 1
      },
      rowsPerPageOptions: [10, 15, 20],
      loginRecordData: {
        loading: false,
        dataLoaded: false,
        columns: [
          { name: 'loginTime', required: true, label: this.$t('labels.date'), align: 'left', field: 'loginTime' },
          { name: 'loginIp', required: true, label: this.$t('labels.acc.loginRecord.loginIp'), align: 'left', field: 'loginIp' }
        ],
        list: [],
        page: {
          page: 1,
          rowsPerPage: 10, // 当前每页显示的行数
          rowsNumber: 1,
          totalPage: 1
        }
      },
      securitySettingRecordData: {
        loading: false,
        dataLoaded: false,
        columns: [
          { name: 'ip', required: true, label: this.$t('labels.acc.loginRecord.loginIp'), align: 'left', field: 'ip' },
          { name: 'action', required: true, label: this.$t('labels.actions'), align: 'left', field: 'action' },
          { name: 'time', required: true, label: this.$t('labels.date'), align: 'left', field: 'time' }
        ],
        list: [],
        page: {
          page: 1,
          rowsPerPage: 10, // 当前每页显示的行数
          rowsNumber: 1,
          totalPage: 1
        }
      },
      pagination: {
        rowsPerPage: 0
      }
    };
  },
  methods: {
    // 获取用户登录记录
    getLoginRecord() {
      let loginRecordData = this.loginRecordData;
      this.loginRecordData.loading = true;
      loginRecordApi
        .getLoginRecord({
          page: loginRecordData.page.page,
          size: loginRecordData.page.rowsPerPage
        })
        .then(res => {
          let data = res.data;
          loginRecordData.list = data.records;
          loginRecordData.page.totalItem = data.total;
          loginRecordData.page.totalPage = data.pages;
          this.loginRecordData.loading = false;
          loginRecordData.dataLoaded = true;
        })
        .catch(() => {
          this.loginRecordData.loading = false;
        });
    },
    // 获取用户安全设置记录
    getSecurityRecord() {
      let securityRecordData = this.securitySettingRecordData;
      this.securitySettingRecordData.loading = true;
      loginRecordApi
        .getSecurityRecord({
          page: securityRecordData.page.page,
          size: securityRecordData.page.rowsPerPage
        })
        .then(res => {
          let data = res.data;
          securityRecordData.list = data.records;
          securityRecordData.page.rowsNumber = data.total;
          securityRecordData.page.totalPage = data.pages;
          this.securitySettingRecordData.loading = false;
          securityRecordData.dataLoaded = true;
        })
        .catch(() => {
          this.securitySettingRecordData.loading = false;
        });
    },
    // 登录记录分页请求
    loginRecordRequestRow(current) {
      this.loginRecordData.page.page = current;
      this.getLoginRecord();
    },
    // 安全设置历史分页请求
    securityRecordRequestRow(current) {
      this.securitySettingRecordData.page.page = current;
      this.getSecurityRecord();
    },
    // 替换路由
    replaceRoute() {
      // let data = this.params.type == 1 ? this.loginRecordData : this.securitySettingRecordData;
      // this.$router.replace(`/usercenter/login-record?type=${this.params.type}`);
    },
    // tab select事件
    _tabSelect(tabName) {
      switch (tabName) {
        case 0:
          this.params.type = 1;
          if (!this.loginRecordData.dataLoaded) {
            this.getLoginRecord();
          }
          break;
        case 1:
          this.params.type = 2;
          if (!this.securitySettingRecordData.dataLoaded) {
            this.getSecurityRecord();
          }
          break;
      }
      this.replaceRoute();
    }
  },
  computed: {
    clientType() {
      return tool.arrayConvertToObject(selectOption.clientType);
    },
    loginStatus() {
      return {
        '0': '失败',
        '1': '成功'
      };
    },
    operateStatus() {
      return {
        '0': '失败',
        '1': '成功'
      };
    }
  },
  mounted() {
    let query = this.$route.query;
    let type = query.type;
    if (!type) {
      type = 1;
    }
    this.params.type = type * 1;
    if (!query.type) {
      this.replaceRoute();
    }

    if (type == 1) {
      this.tabsModel = 'xtab-1';
      this.getLoginRecord();
    } else {
      this.tabsModel = 'xtab-2';
      this.getSecurityRecord();
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../common/styles/mixin/loginRecord-messages.scoped.styl';

/* @import "login-record.scoped.styl" */
.v-tabs::v-deep{
  .v-slide-group__prev{
    display: none !important;
  }
}
</style>
